import {
  Avatar,
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Divider,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Persona,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  Radio,
  RadioGroup,
  Tooltip,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import "./navMenu.css";
import i18n from "i18next";
import {
  ArrowExitRegular,
  Dismiss24Regular,
  EarthFilled,
  EarthRegular,
  LocalLanguageFilled,
  LocalLanguageRegular,
} from "@fluentui/react-icons";
import { useEffect, useState } from "react";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import Manage from "../../Account/Manage/Manage";
import authService from "../../api-authorization/AuthorizeService";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { isTouchDevice } from "../../../helpers/helperMethods";

interface INavMenuEditUserDialogProps {
  user: IAppUserDto;
  small?: boolean;
  border?: boolean;
}

function NavMenuEditUserDialog(props: INavMenuEditUserDialogProps) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState<number | null>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /*Für die Sprache*/
  const [selectLanguageOpen, setSelectLanguageOpen] = useState<boolean>(false);
  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    if (props.user) {
      fetchWrapper
        .getWithAuth(`${baseUrl}/api/account/setlanguage?language=${lang}`)
        .then((result) => {
          console.log(result);
        });
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {props.small == true && (
        <Popover open={selectLanguageOpen}>
          <PopoverTrigger>
            <Tooltip
              positioning="below"
              visible={hovered == 1000 && scrollPosition == 0}
              content={{
                children: (
                  <>
                    {hovered === 1000 && scrollPosition == 0 && (
                      <>
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            opacity: hovered === 1000 ? 1 : 0,
                            color: "#ff6600",
                            fontSize: "13px",
                            transition:
                              "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                          }}
                        >
                          {i18n
                            .t<string>("sprache")
                            .split("")
                            .map((char, charIndex) => (
                              <span
                                key={charIndex}
                                style={{
                                  display: "inline-block",
                                  opacity: 0,
                                  transform: "translateX(-10px)",
                                  animation:
                                    hovered === 1000
                                      ? `fadeInMove 0.135s ease forwards ${
                                          charIndex * 0.0225
                                        }s`
                                      : "none",
                                }}
                              >
                                {char}
                              </span>
                            ))}
                        </span>
                        <style>
                          {` 
                                    @keyframes fadeInMove { 
                                      to { 
                                        opacity: 1; 
                                        transform: translateX(0); 
                                      } 
                                    } 
                                  `}
                        </style>
                      </>
                    )}
                  </>
                ),
                style: {
                  backgroundColor: "#faf9f8ad",
                  boxShadow:
                    scrollPosition > 0 ? "lightgrey 0px 0px 6px 3px" : "",
                  backdropFilter: scrollPosition > 0 ? "blur(6px)" : "",
                  filter: "unset",
                  padding: "0px",
                },
              }}
              relationship={"label"}
            >
              <Button
                size="large"
                style={{
                  paddingLeft: "7px",
                  paddingRight: "7px",
                  minWidth: "40px",
                  minHeight: "40px",
                  height: "40px",
                  width: "40px",
                  display: "flex",
                  justifyContent: "flex-start",
                  transition: "width 0.1125s ease-in-out",
                  overflow: "hidden",
                }}
                onMouseEnter={() => {
                  if (isTouchDevice() == false) {
                    setHovered(1000);
                  }
                }}
                onMouseLeave={() => {
                  setHovered(null);
                }}
                appearance="transparent"
                icon={
                  selectLanguageOpen == true ? (
                    <EarthFilled color="#ff6600" />
                  ) : (
                    <EarthRegular />
                  )
                }
                onClick={() => {
                  setSelectLanguageOpen(!selectLanguageOpen);
                }}
              />
            </Tooltip>
          </PopoverTrigger>
          <PopoverSurface
            onMouseLeave={() => {
              setSelectLanguageOpen(false);
            }}
          >
            <h4 style={{ fontWeight: 700 }}>
              {i18n.t<string>("spracheAuswaehlen")}
            </h4>
            <RadioGroup value={i18n.language.includes("de") ? "de" : "en"}>
              <Radio
                onClick={() => {
                  if (i18n.language.includes("en")) {
                    setLanguage("de");
                    navigate(0);
                    setSelectLanguageOpen(false);
                  }
                }}
                value={"de"}
                label={"Deutsch"}
              />
              <Radio
                onClick={() => {
                  if (i18n.language.includes("de")) {
                    setLanguage("en");
                    navigate(0);
                    setSelectLanguageOpen(false);
                  }
                }}
                value={"en"}
                label={"English"}
              />
            </RadioGroup>
          </PopoverSurface>
        </Popover>
      )}
      {props.small && (
        <Button appearance="transparent" size="small" className="avatarButton">
          <Avatar
            onClick={() => {
              navigate("/account");
            }}
            className="avatarButton"
            style={{ marginRight: "10px" }}
            color="colorful"
            name={props.user.fullName}
          />
        </Button>
      )}
      {!props.small && (
        <Button
          size="small"
          appearance="transparent"
          className="avatarButton"
          onClick={() => {
            navigate("/account");
          }}
        >
          <Persona
            size="large"
            name={props.user.fullName}
            avatar={{ color: "colorful" }}
            secondaryText={props.user.firma}
          />
        </Button>
      )}
      {!props.small && (
        <Tooltip
          visible={hovered === 2000 && scrollPosition == 0}
          content={{
            children: (
              <>
                {hovered === 2000 && scrollPosition == 0 && (
                  <>
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        opacity: hovered === 2000 ? 1 : 0,
                        /* marginLeft:
                                      hovered === index ? "10px" : "0", */
                        color: "#ff6600",
                        fontSize: "13px",
                        transition:
                          "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                      }}
                    >
                      {i18n
                        .t<string>("logout")
                        .split("")
                        .map((char, charIndex) => (
                          <span
                            key={charIndex}
                            style={{
                              display: "inline-block",
                              opacity: 0,
                              transform: "translateX(-10px)",
                              animation:
                                hovered === 2000
                                  ? `fadeInMove 0.135s ease forwards ${
                                      charIndex * 0.0225
                                    }s`
                                  : "none",
                            }}
                          >
                            {char}
                          </span>
                        ))}
                    </span>
                    <style>
                      {` 
                @keyframes fadeInMove { 
                  to { 
                    opacity: 1; 
                    transform: translateX(0); 
                  } 
                } 
              `}
                    </style>
                  </>
                )}
              </>
            ),
            style: {
              backgroundColor: "#faf9f8ad",
              boxShadow: scrollPosition > 0 ? "lightgrey 0px 0px 6px 3px" : "",
              backdropFilter: scrollPosition > 0 ? "blur(6px)" : "",
              filter: "unset",
              paddingTop: "0px",
            },
          }}
          relationship={"label"}
          positioning="below"
        >
          <Button
            onMouseEnter={() => {
              if (isTouchDevice() == false) {
                setHovered(2000);
              }
            }}
            onMouseLeave={() => {
              setHovered(null);
            }}
            size="large"
            icon={<ArrowExitRegular fontSize={24} />}
            appearance="transparent"
            onClick={() => authService.signOut("/").then((result: any) => {})}
          />
        </Tooltip>
      )}

      {/* <Dialog modalType="modal" open={isUserModalOpen}>
        <DialogTrigger disableButtonEnhancement></DialogTrigger>
        <DialogSurface
          onBlur={() => {
            setIsUserModalOpen(false);
          }}
        >
          <DialogBody>
            <DialogTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div>{i18n.t<string>("manageAccountText")}</div>

                <Button
                  onClick={() => {
                    setIsUserModalOpen(false);
                  }}
                  appearance="transparent"
                  icon={<Dismiss24Regular />}
                ></Button>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: "80vh" }}>
              <Manage />
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog> */}
    </div>
  );
}
export default NavMenuEditUserDialog;
